module.exports = __webpack_public_path__ + "img/zk-icon-member.e4f49f0b.svg";